// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import LectureLessonListResourcePagingResultViewModel from '../../../../viewModel/resource/LectureLessonListResourcePagingResultViewModel';
import Int64LookupResourceListResultViewModel from '../../../../viewModel/resource/Int64LookupResourceListResultViewModel';
import LectureLessonListModuleListResourceViewModel from '../../../../viewModel/resource/LectureLessonListModuleListResourceViewModel';
import LectureLessonListModuleListResourceDTO from '../../dto/resource/LectureLessonListModuleListResourceDTO';

export default abstract class LectureLessonListModuleListResourceModel extends BaseModel<LectureLessonListModuleListResourceDTO> {
  /**
  */
  get lessons() { return this.getObjectModel(() => this.dto.lessons, LectureLessonListResourcePagingResultViewModel)!; }
  set lessons(value) { this.setObjectModel(() => this.dto.lessons, value); }
  /**
  */
  get modules() { return this.getObjectModel(() => this.dto.modules, Int64LookupResourceListResultViewModel)!; }
  set modules(value) { this.setObjectModel(() => this.dto.modules, value); }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
  }
}
